import React from 'react';
import { createPopup, closePopup } from '../../services/popupService';
import { PopupWrapper, NewPopupTitle, NewPopupSubtitle, Checkbox, CheckBoxWrapper } from './Popups.styles';
import { ButtonHolder, CommonBlueButton } from '../common/buttonsComponents';
import { expertReviewAcknowledgement } from 'api/expert';

class ExpertReviewNotificationPopup extends React.Component {
  state = {
    doNotShowThisMessageAgain: false,
  };

  handleAcknowledgeButtonClick(e) {
    const { doNotShowThisMessageAgain } = this.state;
    if (doNotShowThisMessageAgain) {
      // update expert field expertReviewPopupAcknowledged
      expertReviewAcknowledgement(this.props.expertId);
    }
    closePopup();
  }

  handleCheckBoxClick() {
    this.setState({ doNotShowThisMessageAgain: !this.state.doNotShowThisMessageAgain });
  }

  render() {
    const { doNotShowThisMessageAgain } = this.state;

    return (
      <PopupWrapper>
        <NewPopupTitle>This is a review ticket</NewPopupTitle>
        <NewPopupSubtitle>Please review the previous expert's response.</NewPopupSubtitle>
        <NewPopupSubtitle>
          <strong>Upon resolving or escalating this ticket</strong>, you will be asked to evaluate the quality of the
          previous expert's response.
        </NewPopupSubtitle>
        <NewPopupSubtitle>
          <strong>If you respond and resolve the ticket</strong>, you will receive your normal ticket pay, but if you
          escalate the ticket you will get escalation pay.
        </NewPopupSubtitle>
        <CheckBoxWrapper>
          <Checkbox
            type="checkbox"
            checked={doNotShowThisMessageAgain}
            onChange={(e) => this.handleCheckBoxClick(e)}
          ></Checkbox>
          <p>Do not show this message again</p>
        </CheckBoxWrapper>
        <br />
        <ButtonHolder>
          <CommonBlueButton width={'100%'} onClick={(e) => this.handleAcknowledgeButtonClick(e)}>
            Acknowledge
          </CommonBlueButton>
        </ButtonHolder>
      </PopupWrapper>
    );
  }
}

const showExpertReviewNotificationPopup = (simplrExpertId) =>
  createPopup({
    type: 'ExpertReviewNotificationPopup',
    title: null,
    content: <ExpertReviewNotificationPopup expertId={simplrExpertId} />,
    noOverlay: false,
    closeOnOutsideClick: false,
  });

export { showExpertReviewNotificationPopup };
